"use client"

import FooterGroup from "@/components/footer-group"
import { TamdaOneFooterViewClientProps } from "@/types/types"

export function TamdaOneFooterViewClient({
  locale,
  aboutLinks,
  infoLinks,
  copyright,
  office = "Văn phòng & chi nhánh",
  about = "Về Tamda Group",
  info = "Thông tin",
  settings,
}: TamdaOneFooterViewClientProps) {
  return (
    <FooterGroup
      locale={locale}
      aboutLinks={aboutLinks}
      infoLinks={infoLinks}
      office={office}
      about={about}
      info={info}
      copyrightFallback={copyright}
      settings={settings}
    />
  )
}
